const questionVisibility = Object.freeze({
    PUBLIC: 0,
    PRIVATE: 1,
    FLOW: 5,
    OTHERS: 100 // private question for not current user
});

/**
 * Question bank question used in chat.
 */
class ChatQuestionResponse {
    constructor({
        id = 0,
        text = ''
    }) {
        this.id = Number(id);
        this.text = text;
    }
}

class ChatQuestion {
    constructor({
        id = 0,
        label = '',
        question = '',
        type = 0,
        typeLabel = '',
        responses = [],
        free_response = false,
        archived = false,
        visibility = 1,
        flow_uuid = null
    }) {
        this.id = Number(id);
        this.label = label;
        this.question = question;
        this.type = Number(type);
        this.typeLabel = typeLabel;
        this.responses = [];
        if (Array.isArray(responses)) {
            responses.forEach((obj) => {
                this.responses.push(new ChatQuestionResponse(obj));
            });
        }
        this.free_response = !!free_response; // bool
        this.archived = !!archived; // bool
        this.visibility = Number(visibility);
        this.flow_uuid = flow_uuid;
    }

    get htmlLabel() {
        return `${this.label}${this.visibility === questionVisibility.PRIVATE ? ' (p)' : ''}`;
    }

    getLabelByResponseId(responseId) {
        const response = this.responses.find((r) => r.id === responseId);
        if (!response) {
            return '';
        }
        return response.text;
    }

    isMultiChoice() {
        return this.type === 1; // QuestionBankConstants::TYPE_CHOICE
    }
}

/**
 * Patron answers to the question.
 */
class ChatAnswer {
    /**
     * @prop {Number} questionId Id of the ChatQuestion
     * @prop {String} question Question text (from ChatQuestion.question)
     * @prop {String} text Free text or label for the responseId (via ChatQuestion)
     * @prop {Number} responseId Id of response chosen (if any)
     */
    constructor({
        questionId = 0,
        question = '',
        text = '',
        responseId = 0
    }) {
        this.questionId = Number(questionId);
        this.question = question;
        this.text = text;
        this.responseId = Number(responseId);
    }
}

export {
    ChatQuestion,
    ChatQuestionResponse,
    ChatAnswer,
    questionVisibility
};
